import { Mesh } from "../basePass";

export class GMeshGenerator {
    static GeneratePolyboardVertical(subdivisionsY: number): { vertices: number[]; texCoords: number[] } {
        const vertices: number[] = [];
        const texCoords: number[] = [];

        // Iterate through subdivisions in the y-axis
        for (let y = 1; y <= subdivisionsY; y++) {
            const v1 = (y - 1) / subdivisionsY; // Starting v-coordinate for the row
            const v2 = y / subdivisionsY; // Ending v-coordinate for the row

            // First triangle of the first square
            vertices.push(-1, v1 - 0.5); // x, y
            vertices.push(0, v1 - 0.5); // x, y
            vertices.push(-1, v2 - 0.5); // x, y

            texCoords.push(0, v1);
            texCoords.push(0.5, v1);
            texCoords.push(0, v2);

            // Second triangle of the first square
            vertices.push(0, v1 - 0.5); // x, y
            vertices.push(0, v2 - 0.5); // x, y
            vertices.push(-1, v2 - 0.5); // x, y

            texCoords.push(0.5, v1);
            texCoords.push(0.5, v2);
            texCoords.push(0, v2);

            // First triangle of the second square
            vertices.push(0, v1 - 0.5); // x, y
            vertices.push(1, v1 - 0.5); // x, y
            vertices.push(1, v2 - 0.5); // x, y

            texCoords.push(0.5, v1);
            texCoords.push(1, v1);
            texCoords.push(1, v2);

            // Second triangle of the second square
            vertices.push(0, v1 - 0.5); // x, y
            vertices.push(1, v2 - 0.5); // x, y
            vertices.push(0, v2 - 0.5); // x, y

            texCoords.push(0.5, v1);
            texCoords.push(1, v2);
            texCoords.push(0.5, v2);
        }

        return { vertices, texCoords };
    }

    static GeneratePlane(gl: WebGL2RenderingContext, pMesh: Mesh) {
        const planeVertices = [-1, -1, 0, -1, 1, 0, 1, 1, 0, 1, 1, 0, 1, -1, 0, -1, -1, 0];
        const planeVertexBufferCPU = new Float32Array(planeVertices);
        pMesh.VertexBufferGPU = gl.createBuffer();
        //Upload from CPU to GPU
        gl.bindBuffer(gl.ARRAY_BUFFER, pMesh.VertexBufferGPU);
        gl.bufferData(gl.ARRAY_BUFFER, planeVertexBufferCPU, gl.STATIC_DRAW);

        {
            const planeTexCoords = [0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            const planeTexCoordsBufferCPU = new Float32Array(planeTexCoords);
            pMesh.TexCoordsBufferGPU = gl.createBuffer();
            //Upload from CPU to GPU
            gl.bindBuffer(gl.ARRAY_BUFFER, pMesh.TexCoordsBufferGPU);
            gl.bufferData(gl.ARRAY_BUFFER, planeTexCoordsBufferCPU, gl.STATIC_DRAW);
        }
        {
            const planeNormal = [0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1];
            const planeNormalBufferCPU = new Float32Array(planeNormal);
            pMesh.NormalsBufferGPU = gl.createBuffer();
            //Upload from CPU to GPU
            gl.bindBuffer(gl.ARRAY_BUFFER, pMesh.NormalsBufferGPU);
            gl.bufferData(gl.ARRAY_BUFFER, planeNormalBufferCPU, gl.STATIC_DRAW);
        }
        {
            const planeTangent = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1];
            const planeTangentBufferCPU = new Float32Array(planeTangent);
            pMesh.TangentsBufferGPU = gl.createBuffer();
            //Upload from CPU to GPU
            gl.bindBuffer(gl.ARRAY_BUFFER, pMesh.TangentsBufferGPU);
            gl.bufferData(gl.ARRAY_BUFFER, planeTangentBufferCPU, gl.STATIC_DRAW);
        }

        //VAO
        pMesh.GenerateVAO(gl);

        pMesh.NumVertices = 6;

        pMesh.bCanDraw = true;
    }
}
